import * as API from "@/services/API";

export default {
    getMetodos(){
        return API.apiClient.get("/metodos-pago");
    },
}